import { makeStyles } from "@mui/styles";

const useHeaderStyles = makeStyles((theme: any) => ({
  appBar: {
    zIndex: 1300,
    background: " #22253b"
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  menuButton: {
    marginRight: 8,
    color: "white"
  },
  leftBox: {
    display: "flex",
    alignItems: "center",
  },
  logo: {
    cursor: "pointer",
  },
  title: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    fontWeight: 600,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  rightBox: {
    display: "flex",
    alignItems: "center",
    gap: 16,
  },
  countryBox: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontWeight: 500,
  },
  flag: {
    width: 24,
    height: 18,
  },
  avatar: {
    backgroundColor: "#e3f2fd", // Light blue background
    color: "#1565c0", // Dark blue text for good contrast
  },
  avatarButton: {
    padding: 0,
  },
  switch: {
    marginLeft: 8,
  },
}));

export default useHeaderStyles;